"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALIDATION_ERROR = exports.TITLEBOX_HEIGHT = exports.TEXTAREA_OVERFLOW = exports.REVIEWBOX_HEIGHT = void 0;
var TEXTAREA_OVERFLOW = 'auto';
exports.TEXTAREA_OVERFLOW = TEXTAREA_OVERFLOW;
var VALIDATION_ERROR = 'error';
exports.VALIDATION_ERROR = VALIDATION_ERROR;
var TITLEBOX_HEIGHT = {
  DESKTOP: '48px',
  MOBILE: '64px'
};
exports.TITLEBOX_HEIGHT = TITLEBOX_HEIGHT;
var REVIEWBOX_HEIGHT = {
  DESKTOP: '128px',
  MOBILE: '88px'
};
exports.REVIEWBOX_HEIGHT = REVIEWBOX_HEIGHT;